/* Module for IRA service https://prod.ibkr-web.com/ibconfluence/display/CASHIER/IRA+REST+Service+for+Portal */
import iraApi from '@ibkr/clientportal.common/src/api/iraApi.js'

export const types = {
    SET_IRA_CONTRIBUTIONS: 'SET_IRA_CONTRIBUTIONS',
}

const state = {
    contributions: {},
}

const getters = {

}

const mutations = {
    [types.SET_IRA_CONTRIBUTIONS](state, { contributions, acctId }) {
        Vue.set(state.contributions, acctId, contributions);
    },
}

const actions = {

    getIRAContributions({ commit, dispatch, state }, { acctId }) {
        iraApi.getIRAContributions(acctId)
            .then((res) => {
                commit(types.SET_IRA_CONTRIBUTIONS, { contributions: res?.contributionTotals, acctId });
            });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
